<template>
  <div>
    <a href="#" @click.prevent="tLogin">
      <span class="sns-center">
        <span class="icon-sns icon-tworld"></span>
        <span class="txt-sns">T아이디로 시작하기</span>
      </span>
    </a>
  </div>
</template>

<script>
import { get } from 'lodash'
import { parseUrl } from 'query-string'
import utils from '@/common/util/utils'
import { UserService } from '@/common/api/api.service'

export default {
  name: 'BtnSkt',
  data () {
    return {
      signupResultCode: '302'
    }
  },
  props: {
    promotionCode: {
      type: String
    }
  },
  methods: {
    tLogin () {
      const { query: currentQuery } = parseUrl(location.href)
      const referer = get(currentQuery, 'referer', '')
      const { query: refererQuery } = parseUrl(referer)
      const promotionCode = get(refererQuery, 'promotioncode', '')
      UserService.getSktToken({ promotionCode }).then((response) => {
        const webUrl = get(response, ['data', 'weburl'], '')
        const queryReferer = get(this.$route, ['query', 'referer'], '')
        if (queryReferer !== '') {
          utils.cookies.setItem('referer-url', queryReferer)
        }
        location.href = webUrl + '&returnurl=' + queryReferer
      })
    }
  }
}
</script>
